import React, { useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { mount } from 'redom';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import application from 'application';

import HelptapEditor from '../../helpers';

import BaseElement from '../base';

import SourceCodeEditor from './editor';

import './index.scss';

function SourceCodeRegion(props) {

  const element = props.element;

  const editor = useSlateStatic();
  const mainReference = useRef(null);
  const sourceCodeEditorReference = useRef(null);

  const elementPath = ReactEditor.findPath(editor, element);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sourceCodeChangeHandler = useCallback(handleSourceCodeChange, []);

  useEffect(function onLoad() {

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(function onPropsChange() {

    sourceCodeEditorReference.current?.sourceFileInput?.editor?.resize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.element.height]);

  async function initializeSourceCodeEditor() {

    await application.dynamicModulesManager.load('ace');

    if (mainReference.current === null) {
      return;
    }

    if (sourceCodeEditorReference.current !== null) {
      return;
    }

    sourceCodeEditorReference.current = new SourceCodeEditor({
      files: element.properties.files,
      onChange: sourceCodeChangeHandler
    });

    mount(mainReference.current, sourceCodeEditorReference.current);

  }

  async function initialize() {

    await initializeSourceCodeEditor();

  }

  function handleSourceCodeChange(files) {

    HelptapEditor.setAttributes(editor, {
      properties: { files }
    }, elementPath);

  }

  function renderSourceCodeRegion() {

    const mainAttributes = {
      ...props.attributes,
      contentEditable: false,
      className: 'source-code-region-main'
    };

    const containerAttributes = {
      contentEditable: false,
      style: { userSelect: 'none' },
      ref: mainReference
    };

    return <div {...mainAttributes}>
      <div {...containerAttributes}>
      </div>
      {props.children}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'source-code-region-wrapper'
    };

    return <BaseElement {...baseElementProperties}>
      {renderSourceCodeRegion()}
    </BaseElement>;

  }

  return renderMain();

}

export default SourceCodeRegion;